import React from 'react';
import { Eye } from 'lucide-react';
import { StatusTag } from './StatusTag';
import ProductLogo from '../../ProductLogo/ProductLogo';
import LogoImage from '../../ProductLogo/LogoImage';

export const DataContractCard = ({
  id,
  name,
  description,
  status,
  lastUpdated,
  dataSource,
  consumers,
  slaCompliance,
  dataQuality,
  freshness,
  onViewDetails,
  logoIds,
}) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'healthy':
        return 'bg-green-50 border-green-200';
      case 'warning':
        return 'bg-amber-50 border-amber-200';
      case 'critical':
        return 'bg-red-50 border-red-100';
      default:
        return 'bg-white border-gray-200';
    }
  };

  const getActionButtonClasses = () => {
    const base =
      'flex items-center gap-1 px-3 py-1.5 bg-white/80 text-gray-700 rounded-lg transition-all duration-200 text-sm font-[20px] border border-white/50 hover:shadow-sm h-10';

    switch (status) {
      case 'healthy':
        return `${base} hover:bg-white  mr-2 mb-2 pl-0 pr-6 hover:text-green-600  hover:font-bold hover:border-[#16a34a]`;
      case 'warning':
        return `${base} hover:bg-white  mr-2 mb-2 pl-0 pr-6 hover:text-yellow-600  hover:font-bold hover:border-[#f59e0b]`;
      case 'critical':
        return `${base} hover:bg-white  mr-2 mb-2 pl-0 pr-6 hover:text-red-600 hover:font-bold hover:border-red-600`;
      default:
        return `${base} hover:bg-[#FF03F3]  mr-2 mb-2 pl-0 pr-6 hover:text-white  hover:font-bold hover:border-[#FF03F3]`;
    }
  };

  return (
    <div onClick={onViewDetails} className={`relative cursor-pointer group bg-gradient-to-br ${getStatusStyles()} backdrop-blur-sm border rounded-xl p-4 pt-3 hover:shadow-xl transition-all duration-300 hover:scale-[1.02]`} style={{ width: '296px', height: '260px' }}>
      {/* Status Tag */}
      <div className="absolute top-4 right-2">
        <StatusTag status={status} animate={status === 'critical'} />
      </div>
      
      {/* Header */}
      <div className="mb-4 ">
        {/* <ProductLogo productId={id} placeholderWidth={"w-5"} /> */}
        <div className="ml-1 inline-flex items-center gap-2">
          {logoIds?.map((l) => (
            <LogoImage key={l} logoId={l} />
          ))}
        </div>
        <div className="flex items-center gap-2 mb-2 pr-20">
          <h3 className="font-semibold text-gray-900 text-lg w-full">{name}</h3>
        </div>
        <p 
          className="text-gray-600 text-sm leading-relaxed line-clamp-5"
          title={description}
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 5,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {description}
        </p>
      </div>

      
      {/* Footer */}
      <div className=" absolute bottom-2 right-1 pt-3 border-t border-white/50">
        <div className="flex items-end justify-end">
         
          <button
            onClick={onViewDetails}
            className={getActionButtonClasses()}
          >
            <Eye className="h-5" />
            View Details
          </button>
        </div>
      </div>

      {/* Hover overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
    </div>
  );
};
